import DynamicZoneComponent from "@components/strapi/DynamicZoneComponent";

export default function DynamicZone(props: { parentProps: unknown, components: unknown[] }) {
  return <>
    {(props.components ?? []).map((componentProps: unknown, index: number) =>
      <DynamicZoneComponent key={index} componentProps={componentProps} index={index} parentProps={props.parentProps}></DynamicZoneComponent>
    )}
  </>
}
